export const DYSLEXIA_SCREENER_LIST_STATUS_COMPLETE = 'Complete';
export const DYSLEXIA_SCREENER_LIST_STATUS_NOT_STARTED = 'Not Started';

export type DyslexiaScreenerListRowStatus =
  | typeof DYSLEXIA_SCREENER_LIST_STATUS_COMPLETE
  | typeof DYSLEXIA_SCREENER_LIST_STATUS_NOT_STARTED;

export const DYSLEXIA_SCREENER_LIST_ROW_TYPE_GRADE_1 = 'Grade 1 Screener';
export const DYSLEXIA_SCREENER_LIST_ROW_TYPE_GRADE_KG = 'Grade KG Screener';
export const DYSLEXIA_SCREENER_LIST_ROW_TYPE_TRAINING =
  'Awareness Training Cycle';

export type DyslexiaScreenerListRowType =
  | typeof DYSLEXIA_SCREENER_LIST_ROW_TYPE_GRADE_1
  | typeof DYSLEXIA_SCREENER_LIST_ROW_TYPE_GRADE_KG
  | typeof DYSLEXIA_SCREENER_LIST_ROW_TYPE_TRAINING;

/** One API list record expanded to three UI rows (G1, KG, training). */
export interface DyslexiaScreenerListDisplayRowModel {
  rowId: string;
  recordId: string;
  schoolYear: number;
  districtName: string;
  leaIdentifier: string;
  schoolName: string;
  schoolIdentifier: string;
  kgIEPStudentCount: number;
  grade1IEPStudentCount: number;
  kg504StudentCount: number;
  grade1504StudentCount: number;
  type: DyslexiaScreenerListRowType;
  status: DyslexiaScreenerListRowStatus;
  kgExists?: boolean;
  grade1Exists?: boolean;
  dyslexiaScreenerUpdate?: boolean;
}
